/**
 * Status Bar Component
 * Bottom bar containing Exit, Balance, Search, Settings, and Clock
 */
import type { FC} from 'react';

import { BalanceDisplay } from './BalanceDisplay';
import { SearchButton } from './actions/SearchButton';
import { SettingsButton } from './actions/SettingsButton';
import { useOpenType } from 'core/providers/OpenTypeContext';

import styles from './StatusBar.module.css';

export const StatusBar: FC = () => {
  const { openType } = useOpenType();
  
  // Hide status bar in ingame mode
  if (openType === 'ingame') {
    return null;
  }
  
  return (
    <div className={styles.statusBarContainer}>
      <div className={styles.leftSection}>
        <BalanceDisplay />
      </div>
      
      <div className={styles.rightSection}>
        <div className={styles.actionsGroup}>
          <SearchButton />
          <SettingsButton />
        </div>
      </div>
    </div>
  );
};
